import axios from "axios";

import queryString from "query-string";
import { attachJwtAuthInterceptors } from "./jwtAuthInterceptors";

/**
 * Client for the TDMS V1 API, reached through the backend's proxy mount
 * (REACT_APP_API_URL = <backend>/api/v1 or <backend>/api/peterpans/v1).
 *
 * The browser never holds a TDMS token: guests send no Authorization header,
 * logged-in users send the normal app JWT, and the backend swaps in the
 * correct agent credential before forwarding to TDMS. A 401 from these URLs
 * therefore always means the app JWT is missing or expired.
 */
const wtApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,

    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

attachJwtAuthInterceptors(wtApiClient);

export default wtApiClient;
